@if (src(); as src) {
	<span
		[tuiAvatar]="initials()"
		size="m"
		tuiAvatarOutline
		appearance="primary"
	>
		<img [src]="src" alt="" />
	</span>
} @else {
	<span [tuiAvatar]="'@tui.user' | tuiIcon" size="m" tuiAvatarOutline></span>
}
